import * as ReactService from "@intech/react-service";
import { FuncionarioDados } from "../entidades/FuncionarioDados";
import { FuncionarioEntidade } from "../entidades/FuncionarioEntidade";
import { PesquisaDadosEntidade } from "../entidades/PesquisaDadosEntidade";

class Funcionario extends ReactService.BaseService {
  constructor() {
    super("Funcionario");
  }

  Buscar = () =>
    this.CreateRequest<FuncionarioDados>(ReactService.RequestType.GET, `Buscar`);

  Pesquisar = (dados: PesquisaDadosEntidade) =>
    this.CreateRequest<FuncionarioEntidade[]>(ReactService.RequestType.POST, `Pesquisar`, dados);

  BuscarIdadeCompleta = () =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `BuscarIdadeCompleta`);

  BuscarTempoPatrocinadora = () =>
    this.CreateRequest<string>(ReactService.RequestType.GET, `BuscarTempoPatrocinadora`);

}

export const FuncionarioService = new Funcionario();
